import { ProtocolEncryption } from './protocol-encryption';

export interface MailServerModel {
  id: number;
  defaultServer: boolean;
  customServer: boolean;
  authType?: string;
  oauthProvider?: string;
  clientId?: string;
  clientSecret?: string;
  tenantId?: string;
  accessToken?: string;
  refreshToken?: string;
  tokenExpiry?: string;
  scopes?: string;
  smtpHost: string;
  smtpPort: number;
  smtpEncryption: ProtocolEncryption;
  smtpUsername: string;
  smtpPassword: string;
  smtpFrom: string;
  smtpFromName: string;
  imapHost: string;
  imapPort: number;
  imapEncryption: ProtocolEncryption;
  imapUsername: string;
  imapPassword: string;
}
